import React from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Helmet } from 'react-helmet';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Stats from './components/Stats';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

if (typeof window !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);
}

function App() {

    return (
        <div className="App">
            <Helmet>
                <title>Ishita Dental Clinic - Dr. Sachin Kumar | Gold Medalist Dentist</title>
                <meta name="description" content="Experience world-class dental care with Dr. Sachin Kumar, MDS & BDS Gold Medalist. Expert in Endodontics and Fixed Orthodontics. Located at Renu Complex, Booty More." />
            </Helmet>
            <Navbar />
            <Hero />
            <Services />
            <About />
            <Stats />
            <Testimonials />
            <Contact />
            <Footer />
        </div>
    );
}

export default App;

